module.exports = __webpack_public_path__ + "media/images/city_img/r_1-3b78a7d82f918deccc57f2fb322aeda5.png";